import { Link } from 'react-router-dom'
import { SEO } from '@/components/seo'
import { blogPosts } from '@/data/blog/posts'

function BlogCard({ post }: { post: (typeof blogPosts)[0] }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="block rounded-2xl border border-white/[0.06] bg-gradient-to-br from-white/[0.03] to-white/[0.01] overflow-hidden transition-all duration-400 hover:-translate-y-1 hover:border-accent-teal/20 hover:shadow-[0_20px_40px_rgba(0,0,0,0.3)]"
    >
      <div
        className="h-[180px] flex items-center justify-center relative overflow-hidden"
        style={{ background: post.gradient }}
      >
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(255,255,255,0.15)_0%,transparent_50%)]" />
        <div className="absolute -bottom-5 -right-5 w-[100px] h-[100px] bg-white/10 rounded-full" />
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="w-12 h-12 opacity-90 relative z-10 text-white"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d={post.iconPath} />
        </svg>
      </div>
      <div className="p-6">
        <div className="text-xs font-semibold text-accent-teal uppercase tracking-wider mb-2">
          {post.category}
        </div>
        <h2 className="text-xl font-semibold text-brand-light mb-3 leading-snug">
          {post.title}
        </h2>
        <p className="text-[15px] text-brand-muted leading-relaxed mb-4">{post.excerpt}</p>
        <div className="text-[13px] text-brand-subtle">
          {post.date} · {post.readTime}
        </div>
      </div>
    </Link>
  )
}

export default function BlogIndexPage() {
  return (
    <>
      <SEO
        title="Blog | WealthSpace"
        description="News, updates, and insights from WealthSpace. Read about product launches, company news, and industry recognition."
        url="/blog"
      />

      {/* Hero */}
      <section className="py-20 px-6 text-center max-w-[800px] mx-auto">
        <h1 className="font-serif text-[clamp(32px,5vw,48px)] font-normal text-brand-light mb-4">
          WealthSpace <span className="text-accent-teal italic">Blog</span>
        </h1>
        <p className="text-lg text-brand-muted">
          News, updates, and insights from the team building the future of adviser technology.
        </p>
      </section>

      {/* Blog Grid */}
      <section className="max-w-[1200px] mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogPosts.map((post) => (
            <BlogCard key={post.slug} post={post} />
          ))}
        </div>
      </section>
    </>
  )
}
